import React, { ReactNode } from 'react';

import './header.scss';

type Props = { children: ReactNode };

function Header(props: Props) {
  return (
    <header className="header">
      <h1 className="header-title">
        <span className="header-name">UX</span>
        <span className="header-game">memory</span>
      </h1>
      {props.children}
    </header>
  );
}

export default Header;
